import { createContext } from 'use-context-selector';

import type {
  CampaignFacets,
  SelectedCampaignFilterState,
  SelectedCampaignState,
} from './SelectedCampaignContext.types';

import { CandidateDetailsTab } from '../CandidateContext/searchv3/types';
import { CampaignJobboard, CampaignTab } from './SelectedCampaignContext.types';
import { FilterOrder } from 'clients/types';

export const filtersInitialState: SelectedCampaignFilterState = {
  order: FilterOrder.Desc,
  setOrder: () => {
    throw Error('not implemented');
  },
  labels: [],
  setLabels: () => {
    throw Error('not implemented');
  },
};

export const statsInitialState: Record<CampaignTab, number> = {
  [CampaignTab.New]: 0,
  [CampaignTab.Shortlisted]: 0,
  [CampaignTab.Contacted]: 0,
  [CampaignTab.Matched]: 0,
  [CampaignTab.Hidden]: 0,
};

export const facetsInitialState: CampaignFacets = {
  [CampaignJobboard.Database]: 0,
  [CampaignJobboard.Debanensite]: 0,
  [CampaignJobboard.Indeed]: 0,
  [CampaignJobboard.Jobbird]: 0,
  [CampaignJobboard.Linkedin]: 0,
  [CampaignJobboard.Monsterboard]: 0,
  [CampaignJobboard.NationaleVacaturebank]: 0,
  [CampaignJobboard.Resumeio]: 0,
  [CampaignJobboard.Techniekwerkt]: 0,
  [CampaignJobboard.Uitzendbureau]: 0,
  [CampaignJobboard.Werknl]: 0,
  [CampaignJobboard.StudentJob]: 0,
  [CampaignJobboard.RobinResume]: 0,
  /// TODO WERKZOEKEN: Remove this after release new jobboard
  // [CampaignJobboard.Werkzoeken]: 0,
};

export const selectedCampaignContextInitialState: SelectedCampaignState = {
  campaign: undefined,
  filters: filtersInitialState,
  candidates: { data: [], isLoading: true, total: 0 },
  matches: { data: {}, isLoading: true },
  stats: { data: statsInitialState, isLoading: true },
  facets: { data: facetsInitialState, isLoading: true },
  selectedTab: CampaignTab.New,
  setSelectedTab: () => {
    throw Error('not implemented');
  },
  selectedCandidate: undefined,
  setSelectedCandidate: () => {
    throw Error('not implemented');
  },
  selectedCandidateConfig: {
    candidateDetails: { initialTab: CandidateDetailsTab.CV },
  },
  setSelectedCandidateConfig: () => {
    throw Error('not implemented');
  },
  selectedPage: 1,
  setSelectedPage: () => {
    throw Error('not implemented');
  },
  setVectorSearchEnabled: () => {
    throw Error('not implemented');
  },
  vectorSearchEnabled: false,
};

export const SelectedCampaignContext = createContext(selectedCampaignContextInitialState);
